<template>
    <div class="">
        <div class="box-point-account bg-white max-w-2xl m-auto rounded-10 py-4 px-4">
            <div class="flex justify-between items-center">
                <div class="flex box-name">
                    <div class="my-auto">
                        <img v-if="!profile.isSubsciption" class="icon-user" src="@/assets/user/Button_Profile_Default.svg">
                        <img v-if="profile.isSubsciption" class="icon-user" src="@/assets/user/user-subscription.png">
                    </div>
                    <div class="ml-2 text-18 font-bold text-1-line"
                        :class="{
                            'text-a-yellow-ffaa00': profile.isSubsciption,
                            'text-a-brown-502314': !profile.isSubsciption
                        }"
                    >{{profile?.firstName ?? ''}} {{profile?.lastName ?? ''}}</div>
                    <router-link to="/profile/edit" class="ml-2 my-auto mr-2" @click="trackingService()">
                        <img class="w-5" src="@/assets/icon/ic-edit-brown.svg">
                    </router-link>
                </div>
                <div class="flex">
                    <div class=" bg-a-yellow-ffaa00 rounded-10 flex p-1 cursor-pointer" 
                        @click="gotoPage('/subscription/mypackage')"
                        v-if="profile.isSubsciption">
                        <img class="my-auto h-3 mr-1" src="@/assets/user/Logo@3x.png" />
                        <div class="my-auto mr-1 text-12 lg:text-14 font-bold text-a-brown-502314 flex-shrink-0">{{ lbl.subscription.reward.whopper_gold }}</div>
                        <img class="my-auto h-2.5" src="@/assets/user/Arrow.png" />
                    </div>
                </div>
            </div>
            
            <div>
                <div class="flex mt-2 items-center">
                    <img v-if="isLevelSliver" class="w-6 mr-2" src="../../../../../assets/icon/crown-silver.svg">
                    <img v-if="isLevelGold" class="w-6 mr-2" src="../../../../../assets/icon/crown-yellow.svg">
                    <img v-if="isLevelPlatinum" class="w-6 mr-2" src="../../../../../assets/icon/crown-platinum.svg">
                    <img v-if="isLevelDiamond" class="w-6 mr-2" src="../../../../../assets/icon/crown-diamond.svg">
                    <div class="text-14" :class="[textClassColorLevel]">{{getPointText(FilterNumberFormat(userPoint))}}</div>
                    <router-link to="/point" class="ml-2" @click="clickCrown()">
                        <img class="w-18px" src="../../../../../assets/icon/info.svg">
                    </router-link>
                </div>
            </div>
            <div class="flex flex-col">
                <div class="text-14 font-bold text-a-brown-502314 mt-2">{{getLevelText(profileLevel?.currentLevel)}}</div>
                <div class="flex-1" v-if="!isLevelDiamond">
                    <div class="text-12 text-a-brown-502314 mt-2">
                        {{getPointDescription(FilterNumberFormat(profileLevel?.pointToNextLevel),getTextExpireDate(profileLevel?.expireDate))}}
                    </div>
                    <div class="bg-a-brown-d7c7b8 rounded-full h-2 mt-2">
                        <div class="h-2 rounded-full" :class="[bgClassColorLevel]" :style="{width: getProgressPoint()}"></div>
                    </div>
                </div>
            </div>
            <div class="flex gap-3 mt-4 md:hidden">
                <div class="flex-1">
                    <BrownOutlineBtn customClass="px-3 py-1" @click="gotoPage('/history')">
                        <div class="text-14 ellipsis-1">{{lbl.profile.point_history}}</div>
                    </BrownOutlineBtn>
                </div>
                <div class="flex-1">
                    <BrownOutlineBtn customClass="px-3 py-1" @click="gotoPage('/userlevel')">
                        <div class="text-14 ellipsis-1">{{lbl.profile.benefits}}</div>
                    </BrownOutlineBtn>
                </div>
                <div class="flex-1">
                    <RedButton customClass="px-3 py-1" @click="gotoPage('/subscription')">
                        <div class="text-14 ellipsis-1">{{ lbl.subscription.reward.subscription }}</div>
                    </RedButton>
                </div>
            </div>
            <div class="hidden md:flex mt-4">
                <div>
                    <BrownOutlineBtn customClass="px-3 py-1" @click="gotoPage('/history')">
                        <div class="text-14">{{lbl.profile.point_history}}</div>
                    </BrownOutlineBtn>
                </div>
                <div class="ml-3">
                    <BrownOutlineBtn customClass="px-3 py-1" @click="gotoPage('/userlevel')">
                        <div class="text-14">{{lbl.profile.benefits}}</div>
                    </BrownOutlineBtn>
                </div>
                <div class="ml-3">
                    <RedButton customClass="px-3 py-1" @click="gotoPage('/subscription')">
                        <div class="text-14">{{ lbl.subscription.reward.subscription }}</div>
                    </RedButton>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DatetimeHelper from '@/helper/DatetimeHelper';
import Util from '@/helper/Utility';
//component
import BrownOutlineBtn from '@/components/Button/BrownOutlineBtn.vue';
import RedButton from '@/components/Button/RedButton.vue';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin'
import ModalMixin from '@/mixin/ModalMixin';
import ProfilePointMixin from '@/mixin/ProfilePointMixin';
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    mixins: [AuthStatusMixin, ModalMixin, ProfilePointMixin,LocaleMixin],
    components: {
        BrownOutlineBtn,
        RedButton
    },
    data: function () {
        return {
            progressPoint: '60%',
            profileLevel: null,
        };
    },
    methods: {
        trackingService:function(){
            this.tracking.event('moremenu','click_account_edit_profile');

        },
        clickCrown: function(){
            this.tracking.event('moremenu','click_crown');
        },
        onAccountInit: function () {
            this.getUserLevelInfo();
        },
        gotoPage: function(path){
            this.trackingProcess(path);
            this.$router.push(path);
        },

        trackingProcess: function(path){
          if(path == '/history'){
               this.tracking.event('moremenu','click_point_history');
          }else{
              this.tracking.event('moremenu','click_tier_benefits');
          }
        },

        getUserLevelInfo: function () {
            // ProfilePointMixin
            this.getProfileLevel().then((data) => {
                this.profileLevel = data;
            }).catch((err) => {
                console.log(err);
                this.errorApi(err);
            });
        },
        getProgressPoint: function () {
            let p = this.profileLevel?.progress;
            if (p != null && p != 0) {
                return p + '%';
            }
            return 0 + '%';
        },

        getTextExpireDate: function (expiredate) {
            if (expiredate == null) {
                return '';
            }
            let date = DatetimeHelper.dateShortFormat2(expiredate);
            return date;
        },

        getPointDescription: function (point,datestr) {
            let levelObj = this.profileLevel?.levelDetail.find(x => x.name_en == this.profileLevel?.nextLevel);
            let levelText = "";

            levelText = this.localeCode == '1033' ? levelObj?.name_en : levelObj?.name;
            return Util.stringFormat(this.lbl.profile.point_description,point,datestr,levelText);
        },

        getPointText: function (point) {
            return Util.stringFormat(this.lbl.profile.have_crowns,point);
        },

        getLevelText: function (level) {
            return Util.stringFormat(this.lbl.profile.whopper_level,level);
        }
    },
}
</script>
<style lang="scss" scoped>
 @import "@/style/base/base.scss";
 @import "@/style/base/text.scss";
    .box-point-account {
        background-image: url('../../../../../assets/bg/BG-card@3x.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position-x: center;
        background-position-y: center;
    }
    .icon-user {
        width: 38px;
    }

    .box-name {
        width: calc(100% - 110px);
        @include min-desktop {
            width: calc(100% - 125px);
        }
    }
    .ellipsis-1 {
        height: 20px;
        text-align: center;
        word-break: break-all;
        @extend %ellipsis-1;
    }
</style>
